module.exports = __webpack_public_path__ + "img/sv97.74dd91ce.svg";